
import React from 'react'
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import styled from 'styled-components';

registerLocale('es', es);

const DatePickerContainer = styled.div`
    width: 100%;
    .react-datepicker-wrapper {
        width: 100%;
    }
`
export default function LocalizeDatePicker(props) {
  if (props.fullWidth) {
    return (
      <DatePickerContainer>
        <DatePicker 
          showMonthDropdown
          showYearDropdown 
          {...props} 
        /> 
      </DatePickerContainer>
    )
  }

  return (
    <DatePicker 
      showMonthDropdown
      showYearDropdown 
      {...props} 
    /> 
  )
}